import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type {
  CreateRegistrationRequest,
  CreateRegistrationResponse,
  RegistrationShowResponse,
} from './interfaces';
import { edupassClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';

export const useRegistrationShow = (courseId: number) => {
  const response = useQuery<{ data: RegistrationShowResponse }>({
    queryKey: [clientKeys.useRegistrationShow, courseId],
    queryFn: () => edupassClient.get(`/cursos/${courseId}/registration`),
    enabled: !!courseId,
  });
  return { subscriptions: response.data?.data?.subscriptions, ...response };
};

export const useCreateRegistration = () => {
  const queryClient = useQueryClient();
  return useMutation<
    { data: CreateRegistrationResponse },
    Error,
    CreateRegistrationRequest
  >({
    mutationFn: async ({ courseId, body }: CreateRegistrationRequest) => {
      return edupassClient.post(`/cursos/${courseId}/registration`, body);
    },
    onSuccess: () => {
      queryClient.refetchQueries({
        queryKey: [clientKeys.useCourseDetails],
      });
      queryClient.refetchQueries({
        queryKey: [clientKeys.useRegistrationShow],
      });
    },
  });
};
